<template>
  <div
    class="
      tw-gap-4 tw-grid tw-grid-cols-1
      lg:tw-min-w-[250px] lg:tw-max-w-[256px] lg:tw-m-auto
    "
  >
    <TextField
      id="institutionName"
      v-model="institutionName"
      data-testid="institutionName"
      name="institutionName"
      rules="required|max:256"
      :placeholder="$t('forms.bank_details.institution_name_placeholder')"
      :label="$t('forms.bank_details.institution_name')"
      message="ex. US Bank"
    />
    <TextField
      id="accountHolderName"
      v-model="accountHolderName"
      data-testid="accountHolderName"
      name="accountHolderName"
      rules="required|max:256"
      :placeholder="$t('forms.bank_details.account_holder_name_placeholder')"
      :label="$t('forms.bank_details.account_holder_name')"
    />
    <TextField
      id="accountNumber"
      v-model="accountNumber"
      v-cleave="cleaveOptions.account"
      data-testid="accountNumber"
      name="accountNumber"
      rules="required|min:5|max:17|confirmed:confirmAccountNumber"
      :placeholder="$t('forms.bank_details.account_number_placeholder')"
      :label="$t('forms.bank_details.account_number_placeholder')"
      @input.native="handleCLeaveInput($event, 'accountNumber')"
    >
      <template #label>
        <span class="form-label">
          {{ $t('forms.bank_details.account_number') }}
          <AccountHelpTooltip :locale="$i18n.locale">
            <template #default="{ on }">
              <HelpIcon class="form-icon" v-on="on" />
            </template>
          </AccountHelpTooltip>
        </span>
      </template>
    </TextField>

    <TextField
      id="confirmAccountNumber"
      v-model="confirmAccountNumber"
      v-cleave="cleaveOptions.account"
      data-testid="confirmAccountNumber"
      vid="confirmAccountNumber"
      name="confirmAccountNumber"
      rules="required"
      :placeholder="$t('forms.bank_details.confirm_account_number_placeholder')"
      :label="$t('forms.bank_details.confirm_account_number_placeholder')"
      @input.native="handleCLeaveInput($event, 'confirmAccountNumber')"
    />

    <TextField
      id="routingNumber"
      v-model="routingNumber"
      v-cleave="cleaveOptions.routing"
      data-testid="routingNumber"
      name="routingNumber"
      rules="required|min:9|max:9|confirmed:confirmRoutingNumber"
      :placeholder="$t('forms.bank_details.routing_number_placeholder')"
      :label="$t('forms.bank_details.routing_number_placeholder')"
      @input.native="handleCLeaveInput($event, 'routingNumber')"
    >
      <template #label>
        <span class="form-label">
          {{ $t('forms.bank_details.routing_number') }}
          <AccountHelpTooltip :locale="$i18n.locale">
            <template #default="{ on }">
              <HelpIcon class="form-icon" v-on="on" />
            </template>
          </AccountHelpTooltip>
        </span>
      </template>
    </TextField>

    <TextField
      id="confirmRoutingNumber"
      v-model="confirmRoutingNumber"
      v-cleave="cleaveOptions.routing"
      data-testid="confirmRoutingNumber"
      vid="confirmRoutingNumber"
      name="confirmRoutingNumber"
      rules="required"
      :placeholder="$t('forms.bank_details.confirm_routing_number_placeholder')"
      :label="$t('forms.bank_details.confirm_routing_number_placeholder')"
      @input.native="handleCLeaveInput($event, 'confirmRoutingNumber')"
    />
  </div>
</template>

<script>
import HelpIcon from 'vue-material-design-icons/HelpCircle'
import Cleave from 'cleave.js'
import AccountHelpTooltip from './AccountHelpTooltip'
import TextField from '~/components/form-fields/TextField'

/**
 * TODO: This should be declared somewhere else so it can be applied to all inputs
 * We add a new instance of Cleave when the element
 * is bound and destroy it when it's unbound.
 */
const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  },
}
export default {
  directives: { cleave },
  components: {
    TextField,
    HelpIcon,
    AccountHelpTooltip,
  },
  props: {
    values: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      temporal: '',
      cleaveOptions: {
        account: {
          blocks: [17],
          numericOnly: true,
        },
        routing: {
          blocks: [9],
          numericOnly: true,
        },
      },
    }
  },
  computed: {
    institutionName: {
      get() {
        return this.values.institutionName
      },
      set(value) {
        this.handleChange('institutionName', value)
      },
    },
    accountHolderName: {
      get() {
        return this.values.accountHolderName
      },
      set(value) {
        this.handleChange('accountHolderName', value)
      },
    },
    accountNumber: {
      get() {
        return this.values.accountNumber
      },
      set(value) {
        this.handleChange('accountNumber', value)
      },
    },
    confirmAccountNumber: {
      get() {
        return this.values.confirmAccountNumber
      },
      set(value) {
        this.handleChange('confirmAccountNumber', value)
      },
    },
    routingNumber: {
      get() {
        return this.values.routingNumber
      },
      set(value) {
        this.handleChange('routingNumber', value)
      },
    },
    confirmRoutingNumber: {
      get() {
        return this.values.confirmRoutingNumber
      },
      set(value) {
        this.handleChange('confirmRoutingNumber', value)
      },
    },
  },
  methods: {
    handleChange(key, value) {
      const payload = this.values || {}
      this.$emit('on-change', { ...payload, [key]: value })
    },
    handleCLeaveInput(event, key) {
      this[key] = event.target._vCleave.getRawValue()
    },
  },
}
</script>

<style lang="postcss" scoped>
.form-label {
  @apply tw-flex tw-justify-between tw-items-end;
}

.form-icon {
  font-size: 20px;
}
</style>
